import styled from 'styled-components';
import Header from './Header.jsx';
import Body from './Body.jsx';
import ColumnGroup from './ColumnGroup.jsx';
import Tooltip from '../Tooltip/Tooltip.jsx';
import styles from './table.module.css';

export const TableWrapper = styled.div`
  overflow-x: auto;
  padding-top: 15px;
`;

const Table = ({
  columns,
  body,
  sortingStatus,
  changeSort,
  minWidthBeforeScroll,
  id,
}) => {
  return (
    <TableWrapper>
      <Tooltip id={id} />
      <table
        className={styles.table}
        style={{ minWidth: minWidthBeforeScroll }}
      >
        <ColumnGroup columns={columns} />
        <Header
          columns={columns}
          sortingStatus={sortingStatus}
          changeSort={changeSort}
        />
        <Body body={body} />
      </table>
    </TableWrapper>
  );
};

export default Table;
